import { FBPage } from 'components/FbUI/Page/FBPage'
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import {
  FBPageHeader,
  FBPageTitle,
  FBPageTitleRow,
} from 'components/FbUI/Page/styles'
import { featureFlagService } from 'utils/featureFlagService'
import { useAuth } from 'context/authentication/useAuth'
import { TabKeys, TabGroupKeys } from 'features/settings/components/SideMenu'

import styled from 'styled-components'
import { useEffect } from 'react'
import { useSideMenu } from 'features/settings/context/SideMenuContext'

export function SettingsLayout() {
  const navigate = useNavigate()
  const params = useParams()
  const group = (params?.group ?? 'users') as TabGroupKeys
  const tab = (params?.tab ?? 'users') as TabKeys
  const featureFlags = featureFlagService()
  const { user } = useAuth()
  const { tabGroups } = useSideMenu()
  const currentGroup = tabGroups[group]

  useEffect(() => {
    if (featureFlags.isLoading) {
      return
    }

    if (!currentGroup || !currentGroup.isAllowed(user, featureFlags)) {
      const url = `/settings/users/users`
      navigate(url)
      return
    }

    const currentTab = currentGroup ? currentGroup.tabs?.[tab] : undefined
    if (!currentTab || !currentTab.isAllowed(user, featureFlags)) {
      const firstTab = Object.values(currentGroup.tabs)[0]
      const url = `/settings/${currentGroup.uri}/${firstTab.uri}`
      navigate(url)
      return
    }
  }, [tab, group, featureFlags.isLoading])

  return (
    <FBPage innerPageClassName="h-full">
      <CustomFBPageHeader>
        <FBPageTitleRow>
          <CustomFBPageTitle>
            Settings: <TabTitle>{currentGroup?.title}</TabTitle>
          </CustomFBPageTitle>
        </FBPageTitleRow>
      </CustomFBPageHeader>

      <div className="flex gap-0 flex-1 min-h-0">
        <Outlet />
      </div>
    </FBPage>
  )
}

const CustomFBPageHeader = styled(FBPageHeader)`
  padding: 12px 0;
`

const CustomFBPageTitle = styled(FBPageTitle)`
  font-weight: 400;
  font-size: 24px;
`

const TabTitle = styled.span`
  font-weight: bold;
  font-size: 24px;
  line-height: 28px;
  color: #101828;
  font-size: 24px;
`
